import React from 'react'
import algoliasearch from 'algoliasearch'
import { useSelector } from 'react-redux'
import useThrottle from 'react-use/lib/useThrottle'

import { getSearchApplicationId, getSearchToken } from 'data/config/selectors'

export default function useAlgoliaSearch(query) {
  const searchApplicationId = useSelector(getSearchApplicationId)
  const searchToken = useSelector(getSearchToken)
  const client = React.useMemo(
    () => algoliasearch(searchApplicationId, searchToken),
    [searchApplicationId, searchToken]
  )
  const [results, setResults] = React.useState({
    error: null,
    channels: [],
    notes: [],
  })

  const search = React.useCallback(
    async function search(query) {
      if (query === '') {
        setResults({
          error: null,
          channels: [],
          notes: [],
        })
        return
      }

      client.search(
        [
          {
            indexName: 'channels',
            query,
            params: {
              hitsPerPage: 10,
              restrictSearchableAttributes: ['name'],
            },
          },
          {
            indexName: 'notes',
            query,
            params: {
              hitsPerPage: 20,
              restrictSearchableAttributes: ['title', 'fullPath'],
              filters: `isArchived:false AND isTemplate:false`,
              attributesToRetrieve: [
                'title',
                'channelId',
                'objectID',
                'iconShape',
                'iconColor',
                'fullPath',
                'hasChildren',
              ],
            },
          },
        ],
        (error, { results }) => {
          if (error) {
            setResults({
              error,
              channels: [],
              notes: [],
            })
          }
          const [channelsResults, notesResults] = results
          return setResults({
            error: null,
            channels: channelsResults.hits,
            notes: notesResults.hits,
          })
        }
      )
    },
    [client]
  )

  const throttledQuery = useThrottle(query, 100)

  React.useEffect(
    () => {
      search(throttledQuery)
    },
    [search, throttledQuery]
  )
  return results
}
